class CartNotification extends ModalDialog {
    constructor() {
        super();
        this.notification = document.getElementById('cart-notification');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        );
    }

    open() {
        document.body.addEventListener('click', this.onBodyClick);
        this.show(null);
    }

    close() {
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus(this.activeElement);
        this.hide();
    }

    renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        if (parsedState.sku.includes('B')) {
            document.getElementById('cart-notification-koopjeskelder').innerHTML =
                `<h4 style="color: #f95602; ">Let op! 
                 <br>
                 U bestelt een koopjeskelder artikel. Dit zijn vaak enkele stuks, opendoos- en of demo-modellen met volledige garantie.</h4>`;
        }

        const freeDeliveryBar = document.getElementById('freeDeliveryBar')
        const cartNotificationWeight = parsedState.grams;
        const cartNotificationTotalPrice = parsedState.final_line_price;
        const remainingPrice = 4900 - cartNotificationTotalPrice
        const remainingPriceAsString = (remainingPrice / 100).toLocaleString("nl-NL", {style: "currency", currency: "EUR"});

        if (freeDeliveryBar && cartNotificationWeight <= 30000) {
            if (remainingPrice <= 0) {
                freeDeliveryBar.innerHTML = `<span class="strong">GRATIS VERZENDING</span>`
            } else {
                freeDeliveryBar.innerHTML = `<span>Besteed voor <span class="strong">${ remainingPriceAsString }</span> en betaal <span class="strong">geen €7,99 verzendkosten</span></span>`
            }
        } else {
            freeDeliveryBar.innerHTML = `<span class="strong">€40,00 bezorgkosten of gratis afhalen</span>`
        }

        this.getSectionsToRender().forEach((section => {
            if (document.getElementById(section.id)) {
                document.getElementById(section.id).innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            }
            if (section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')) {
                document.querySelector('#product-page-free-delivery').innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            }
        }));

        this.open();
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
            },
            {
                id: 'cart-notification-button'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'cart-icon-bubble--mobile'
            },
            {
                id: 'cart-free-delivery'
            }
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-notification', CartNotification);